import { connect } from 'react-redux'
import { fetchServicing } from '../../actions/servicings'
import { goBack } from 'react-router-redux'
import get from 'lodash/get'

import ServicingRedoImages from '../../components/servicings/servicing-redo-images'

function mapStateToProps (state, { params: { servicingId } }) {
  const servicing = get(state, `servicings.${servicingId}`)
  if (!servicing) return { loading: true }

  return {
    servicing,
    modalTitle: 'Inspection Images',
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const { servicingId } = ownProps.params
  dispatch(fetchServicing(servicingId))

  return {
    handleClose () {
      dispatch(goBack())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ServicingRedoImages)



// WEBPACK FOOTER //
// ./src/containers/servicings/servicing-redo-images-container.js